import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Register, TreeComponent } from '@xanadu/core';
import { Aspect, Faction, Prototype } from '@xanadu/model';
import { AspectMenuBuilder } from '@xanadu/menu';
import { AspectService } from '@xanadu/service';
import { NodeModel, Node, Branch } from '@xanadu/model';
import { Observable, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-aspect-tree',
    templateUrl: './aspect-tree.component.html',
    styleUrls: ['./aspect-tree.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('aspect-tree')
export class AspectTreeComponent extends TreeComponent<Faction | Aspect> {
    menuBuilder = inject(AspectMenuBuilder);
    aspectService = inject(AspectService);

    private subjectValidate: Subject<any> = new Subject<any>();

    protected override get nodeType(): string | undefined {
        return 'aspect';
    }

    constructor() {
        super();

        this.subjectValidate
            .pipe(
                takeUntilDestroyed(),
                switchMap(aspect => this.aspectService.checkUsage(aspect)))
            .subscribe(usage => {
                const errors = [];
                if (usage) {
                    for (const key in usage) {
                        errors.push(`${key}: ${usage[key].join(' ')}`);
                    }
                }

                if (errors.length) {
                    const message = `Aspect reference found in ${errors.join(', ')}.`;
                    this.noticeSignal.error(message);
                } else {
                    super.onDelete(this.current);
                }
            });
    }

    onFaction() {
        const faction = new Faction(undefined);
        faction.name = 'new faction';
        this.addChild(faction);
    }

    onPrototype() {
        const prototype = new Prototype(undefined);
        prototype.name = 'new prototype';
        this.addChild(prototype);
    }

    onAspect() {
        const aspect = new Aspect(undefined);
        aspect.name = 'new aspect';
        this.addChild(aspect);
    }

    onPaste() {
        this.paste();
    }

    onDelete(model?: NodeModel) {
        this.subjectValidate.next(model?.node);
    }

    protected replace(node: Node, branch: Branch): Observable<Aspect | Faction> {
        return this.dataService.replace<Aspect | Faction>(node as any, branch);
    }

    protected dropOk(dragModel: NodeModel, dropModel: NodeModel): boolean {
        const dragNode = dragModel.node;
        const dropNode = dropModel.node as Branch;

        return dragNode.fit(dropNode);
    }
}
